import TRANSLATE_EN from "./en/translations.json";

export const translations = {
  en: { translation: TRANSLATE_EN },
};